<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <CRow>
              <span class="custom-header-profile">
                <img src="../assets/img/Maskgroup.svg" />
              </span>
            
              <span class="custom-user-title">Name</span>
            </CRow>

            <h4 style="color: #000; text-align: left" class="custom-user-grade">
              Student Nickname
            </h4>

            <br />
            <form class="ml-3 mr-3">
              <input
                type="text"
                class="custom-input-user"
                placeholder="eg. Nazhan"
                v-model="NickName"
                value=""
              />
            </form>            
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>
    <div class="bottom-center mb-5">
      <CButton class="btn-select-blue mt-5" @click="GoToGrade()">Next</CButton>
    </div>
    <div class="header-top">Register Student</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
export default {
   data: function () {
    return {
      NickName: "",
    };
  },
  components: {
    MainlayoutBottom,
  },
  methods: {
    GoToGrade(){
      this.$router.push(
        "/RegisterStudentParentGrade?NickName="+ this.NickName
      );
    },
    GoBack() {
     this.$router.back();
    },
  }
}
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}

.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

</style>